export default function EmptyChangeOrderIcon() {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* document */}
      <rect
        x="10"
        y="8"
        width="36"
        height="44"
        rx="3"
        fill="currentColor"
        opacity="0.08"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      {/* doc lines */}
      <line x1="18" y1="20" x2="38" y2="20" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <line x1="18" y1="27" x2="38" y2="27" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <line x1="18" y1="34" x2="28" y2="34" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      {/* change/swap arrows badge */}
      <circle cx="46" cy="46" r="13" fill="var(--bg2, #fff)" stroke="currentColor" strokeWidth="1.8" />
      {/* arrow right */}
      <path
        d="M40 43h8l-2.5-2.5"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* arrow left */}
      <path
        d="M52 49h-8l2.5 2.5"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
